/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_CurrentInputs */

const en_us2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open now`)
};

const pt_br2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aberta agora`)
};

const es_419_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abierta ahora`)
};

const pt_pt2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aberta agora`)
};

const fr_fr2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ouverte`)
};

const de_de2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gerade offen`)
};

const it_it2_coach_extra_conversations_current = /** @type {(inputs: Coach_Extra_Conversations_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aperta ora`)
};

/**
* | output |
* | --- |
* | "open now" |
*
* @param {Coach_Extra_Conversations_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_current = /** @type {((inputs?: Coach_Extra_Conversations_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_current(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_current(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_current(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_current(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_current(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_current(inputs)
	return en_us2_coach_extra_conversations_current(inputs)
});
export { coach_extra_conversations_current as "coach-extra.conversations_current" }